import { createActions, createReducer } from 'reduxsauce'

import ArquivosLicitacaoService from '../../servicos/ArquivosContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaArquivosLicitacaoInicio: [],
    buscaArquivosLicitacaoSucesso: ['arquivosLicitacao'],
    buscaArquivosLicitacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaArquivosLicitacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaArquivosLicitacaoInicio())
        let serv = new ArquivosLicitacaoService()
        return serv
            .consultarLicitacao(filtro)
            .then(response => dispatch(Creators.buscaArquivosLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaArquivosLicitacaoErro(error)))
    }
}

const buscaArquivosLicitacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaArquivosLicitacaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaArquivosLicitacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.arquivosLicitacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ARQUIVOS_LICITACAO_INICIO]: buscaArquivosLicitacaoInicio,
    [Types.BUSCA_ARQUIVOS_LICITACAO_ERRO]: buscaArquivosLicitacaoErro,
    [Types.BUSCA_ARQUIVOS_LICITACAO_SUCESSO]: buscaArquivosLicitacaoSucesso,
})
